"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderUnsure = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const loader_unsure_style_1 = __importDefault(require("./loader.unsure.style"));
const loader_unsure_bg_svg_1 = __importDefault(require("./loader.unsure.bg.svg"));
class LoaderUnsure extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => (jsx_runtime_1.jsx("div", { role: "none", className: this.props.classes.root, style: { backgroundImage: `url(${loader_unsure_bg_svg_1.default})` } }, void 0));
    }
}
exports.LoaderUnsure = LoaderUnsure;
LoaderUnsure.propTypes = {
    classes: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(loader_unsure_style_1.default)(LoaderUnsure);
//# sourceMappingURL=loader.unsure.js.map